// extracted by mini-css-extract-plugin
module.exports = {"container":"bullets_container__XSTIC","fadeImage":"bullets_fadeImage__2IGs0"};